import { Component, ElementRef, ViewChild, OnInit, ViewChildren, QueryList } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { IonModal, IonSelect, NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { Location } from '@angular/common';
import Keyboard from 'simple-keyboard';
import { NavigationExtras } from '@angular/router';
import { VisitorChild } from 'src/app/registration/models/visitorChild';
import { Visitor } from 'src/app/registration/models/visitor.model';
import { LanguageService } from 'src/app/services/language.service';



@Component({
  selector: 'app-online-registration',
  templateUrl: './online-registration.component.html',
  styleUrls: ['./online-registration.component.scss'],
})
export class OnlineRegistrationComponent implements OnInit {
  inputName = "fullName";
  inputs = {
    fullName: "",
    ['fullNameChild1']: "",
    phone: "",
    phonePrefix: "+381",
    email: "",
    day: "",
    month: "",
    year: ""
  };
  addedChild: VisitorChild;
  language$ = this.languageService.language$;
  language: string;
  dateToday = new Date();
  errMsg = '';
  areTermsRead: boolean = false;
  visitor: Visitor = new Visitor();
  isLoading = false;
  visitors: Array<VisitorChild> = [];
  visitorsRegisterForm: Array<VisitorChild> = [];
  childrenForm: Array<VisitorChild> = [];
  isShow = false;
  isChildFormVisible = false;
  childEdit: VisitorChild;
  routerSubscription;
  children: { fullName: string }[] = [{ fullName: '' }];
  childDate: { month: string, year: string }[] = [{month: '', year: '' }];
  days: string[] = Array.from({ length: 31 }, (_, i) => (i + 1).toString());
  months = Array.from({ length: 12 }, (_, i) => ({ name: (i + 1).toString(), value: (i + 1).toString() }));
  years: string[] = [];
  phonePrefixes = [
{ code: '+381', flag: 'rs' }, // Srbija  
{ code: '+387', flag: 'ba' }, // Bosna i Hercegovina
{ code: '+389', flag: 'mk' }, // Severna Makedonija  
{ code: '+385', flag: 'hr' }, // Hrvatska  
{ code: '+382', flag: 'me' }, // Crna Gora
{ code: '+7',   flag: 'ru' }, // Rusija  
{ code: '+380', flag: 'ua' }, // Ukrajina  
{ code: '+49',  flag: 'de' }, // Nemačka 
{ code: '+355', flag: 'al' }, // Albanija  
{ code: '+376', flag: 'ad' }, // Andora  
{ code: '+43',  flag: 'at' }, // Austrija  
{ code: '+374', flag: 'am' }, // Jermenija  
{ code: '+32',  flag: 'be' }, // Belgija   
{ code: '+359', flag: 'bg' }, // Bugarska  
{ code: '+357', flag: 'cy' }, // Kipar  
{ code: '+420', flag: 'cz' }, // Češka  
{ code: '+45',  flag: 'dk' }, // Danska  
{ code: '+372', flag: 'ee' }, // Estonija  
{ code: '+358', flag: 'fi' }, // Finska  
{ code: '+33',  flag: 'fr' }, // Francuska  
{ code: '+995', flag: 'ge' }, // Gruzija  
{ code: '+30',  flag: 'gr' }, // Grčka  
{ code: '+36',  flag: 'hu' }, // Mađarska  
{ code: '+354', flag: 'is' }, // Island  
{ code: '+353', flag: 'ie' }, // Irska  
{ code: '+39',  flag: 'it' }, // Italija  
{ code: '+371', flag: 'lv' }, // Letonija  
{ code: '+423', flag: 'li' }, // Lihtenštajn  
{ code: '+370', flag: 'lt' }, // Litvanija  
{ code: '+352', flag: 'lu' }, // Luksemburg  
{ code: '+356', flag: 'mt' }, // Malta  
{ code: '+373', flag: 'md' }, // Moldavija  
{ code: '+377', flag: 'mc' }, // Monako  
{ code: '+31',  flag: 'nl' }, // Holandija  
{ code: '+47',  flag: 'no' }, // Norveška  
{ code: '+48',  flag: 'pl' }, // Poljska  
{ code: '+351', flag: 'pt' }, // Portugal  
{ code: '+40',  flag: 'ro' }, // Rumunija  
{ code: '+421', flag: 'sk' }, // Slovačka  
{ code: '+386', flag: 'si' }, // Slovenija  
{ code: '+34',  flag: 'es' }, // Španija  
{ code: '+46',  flag: 'se' }, // Švedska  
{ code: '+41',  flag: 'ch' }, // Švajcarska  
{ code: '+44',  flag: 'gb' }, // Velika Britanija  
{ code: '+90',  flag: 'tr' },  // Turska
{ code: '+1',   flag: 'us' }, // Sjedinjene Američke Države
{ code: '+1',   flag: 'ca' }, // Kanada
{ code: '+61',  flag: 'au' }  // Australija
];
selectedPrefix = this.phonePrefixes[0]; // Default: +381 (Srbija)
dropdownOpen = false;
  
  @ViewChildren('daySelect') daySelects!: QueryList<IonSelect>;
  @ViewChildren('monthSelect') monthSelects!: QueryList<IonSelect>;
  @ViewChildren('yearSelect') yearSelects!: QueryList<IonSelect>;

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private notifierService: NotifierService,
    private modalController: ModalController,
  ) {
    this.childEdit = new VisitorChild();
  this.routerSubscription = this.router.events.subscribe((event: any) => {
  if (event instanceof NavigationEnd &&
      event.urlAfterRedirects === '/registration/online-registration') {

    const state = window.history.state as any;

    if (state && state.resetPage) {
      this.resetPage();
    }
  }

  if (event instanceof NavigationEnd &&
      event.urlAfterRedirects === '/registration/home') {

    this.resetPage();
  }
});

    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 100 }, (_, i) => (currentYear - i).toString());
    
  }
  
  ngOnInit() {
    
    this.visitor = new Visitor();
    this.language$.subscribe((lng) => (this.language = lng.toUpperCase()));
    this.resetPage();
  }
  
  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  toggleLanguage() {
    this.language = this.language === 'EN' ? 'SR' : 'EN';
    this.languageService.setLanguage(this.language.toLowerCase());
  }

  areFirstFieldsPopulated(): boolean {
    const hasParentName = !!this.inputs.fullName?.trim(); 
     const isPhoneValid = !!this.inputs.phone && !isNaN(Number(this.inputs.phone)) && this.inputs.phone.length >= 6;
  const hasPrefix = !!this.inputs.phonePrefix;

  return hasParentName && isPhoneValid && hasPrefix;
}

goToOtherPage() {
  this.fillVisitorData();

  const newChildren = [];
  for (let i = 0; i < this.children.length; i++) {
    const inputKey = 'fullNameChild' + (i + 1);
    const childFullName = this.inputs[inputKey];

    if (childFullName) {

      if (!this.childDate[i].year) {
        this.childDate[i].year = '1800';
      }
      if (!this.childDate[i].month) {
        this.childDate[i].month = '01';
      }
      
      const birthDate = `${this.childDate[i].year}-${this.childDate[i].month.padStart(2, '0')}-01`;

      newChildren.push({
        fullName: childFullName,
        birthDate: birthDate,
      });
    }
  }

  this.visitorsRegisterForm = newChildren;

  let visitorJson = JSON.stringify(this.visitor);
  let visitorsFormJson = JSON.stringify(this.visitorsRegisterForm);

  this.router.navigate(['/registration/online-consent', { visitor: visitorJson, visitorsFormJson }]);
}

  fillVisitorData() {
    this.visitor.fullName = this.inputs.fullName;
    this.visitor.phone = this.inputs.phonePrefix + this.inputs.phone;
    this.visitor.email = this.inputs.email;
  }

  addInputField() {
    if (this.children.length < 100) {
      this.children.push({ fullName: '' });
      this.childDate.push({ month: '', year: '' });
    }
  }

  removeInputField(index: number) {
    if (index >= 0 && index < this.children.length) {
      this.children.splice(index, 1);
      this.childDate.splice(index, 1);
    }
  }

  openSelect(type: string, index: number, event: any) {
    setTimeout(() => {
      let select: IonSelect | undefined;
      
      if (type === 'month') {
        select = this.monthSelects.toArray()[index];
      } else if (type === 'year') {
        select = this.yearSelects.toArray()[index];
      }
      
      if (select) {
        select.open(event);
      }
    }, 100); 
  }

  getMonthName(monthValue: string): string {
    const month = this.months.find(m => m.value === monthValue);
    return month ? month.name : "";
  }

  areNamesValid(): boolean {
    for (let i = 0; i < this.children.length; i++) {
      const inputName = this.inputs['fullNameChild' + (i + 1)];
      if (inputName && !/^[a-zA-Z]+\s[a-zA-Z ]+$/.test(inputName)) {
        return false;
      }
    }
    return true;
  }

  resetPage() {
    this.childEdit = new VisitorChild();
    this.visitor = new Visitor();
    this.visitors = [];
    this.visitorsRegisterForm = [];
  
    this.inputs.fullName = "";
    this.inputs.phone = "";
    this.inputs.email = "";
  
    this.children = [{ fullName: '' }]; 
    this.childDate = [{ month: '', year: '' }];
  
    Object.keys(this.inputs).forEach((key) => {
      if (key.startsWith('fullNameChild')) {
        this.inputs[key] = "";
      }
    });
  }
  
  dismissPopover() {
    setTimeout(() => {
      const popover = document.querySelector('ion-popover');
      if (popover) {
        (popover as any).dismiss();
      }
    }, 100);
  }
  
  isNameInvalid(name: string): boolean {
    if (!name || !name.trim()) return true;
    const words = name.trim().split(/\s+/); 
    return words.length < 2;
  }

  toggleDropdown() {
  this.dropdownOpen = !this.dropdownOpen;
}

selectPrefix(prefix: { code: string; flag: string }) {
  this.selectedPrefix = prefix;
  this.inputs.phonePrefix = prefix.code;
  this.dropdownOpen = false;
}
}




